import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ASNSummay } from '../model/asn';
import { OrderSummay } from '../model/order';
import { DocumentRequest, DocumentResponse} from '../model/document';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  documentSubscription$: Subscription;

  getASNSummary(cusId: string, pageNumber: string, asnNum: string): Observable<ASNSummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: {
        customerId: cusId, responseFilter: 'detail', page: pageNumber, pageLimit: '5',
        asnNumber: asnNum
      }
    };
    return this.http.get<ASNSummay>(environment.apiGetASNURL, httpOptions);
  }

  getOrderSummary(cusId: string, pageNumber: string, ordNum: string, ordType: string): Observable<OrderSummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        customerId: cusId, responseFilter: 'summary', page: pageNumber, pageLimit: '5',
        orderNumber: ordNum, orderType: ordType
      }
    };

    return this.http.get<OrderSummay>(environment.apiOrderURL, httpOptions);
  }

  getStandardDocumentsSummary(facId: string, custId: string, buId: string, pageNumber: string, entityNumber: string, entityType: string) {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        'Api-Platform': 'PURPLE',
        'Wms-Instance-Name': 'DOC',
        FSC_USER: localStorage.getItem('USERID') 
      },
      params: {
        facId: facId, custId: custId, buId: buId, page: pageNumber, pageLimit: '10', entityNumber: entityNumber, entityType: entityType
      }
    };
    let url = environment.apiHouseKeepingURL + '/standardDocuments';
    return this.http.get<any>(url, httpOptions);
  }

  getDocumentsDetails(customerId, entityType, entityNumber, facilityId, businessUnitId): Observable<DocumentResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        customerId: customerId, entityType: entityType, entityNumber: entityNumber
        //, facilityId: facilityId, businessUnitId: businessUnitId
      }
    };

    return this.http.get<DocumentResponse>(environment.apiDocumentsURL, httpOptions);
  }

  getDocumentsDetailsForItem(entityType, entityNumber): Observable<DocumentResponse> {

    const httpOptions = {

      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        entityType: entityType, entityNumber: entityNumber
      }
    };
    return this.http.get<DocumentResponse>(environment.apiDocumentsURL, httpOptions);

  }

  getDocumentsforAsnId(asn,custId): Observable<DocumentResponse> {
    console.log(' REST call....Getting documents for AsnId ' + asn.asnNumber);
    return this.getDocumentsDetails(custId, 'ASN' , asn.asnNumber, asn.destination.facilityCode, asn.destination.businessUnit);
  }

  getDocumentsforOrderNumber(order,custId): Observable<DocumentResponse> {
    console.log(' REST call....Getting documents for OrderNumber ' + order.orderNumber);

    return this.getDocumentsDetails(custId, 'ORDER' , order.orderNumber, order.shipFrom.fcyId, order.shipFrom.buId);
  }

  getDocumentsforEntityNumber(docEntity, custId, fcyId, buId): Observable<DocumentResponse> {
    console.log(' REST call....Getting documents for EntityNumber ' + docEntity.entityNumber);

    return this.getDocumentsDetails(custId, docEntity.entityType , docEntity.entityNumber, fcyId, buId);
  }

  downloadDocuments(downloadIds,requestType): Observable<DocumentResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        edmDocumentId: downloadIds.toString(), requestType: requestType
      }
    };

    return this.http.get<DocumentResponse>(environment.apiDocumentsURL+'/retrieveDocumentByDocId', httpOptions);
  }

  deleteDocuments(documentId,deleteIds,requestType): Observable<DocumentResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        documentId: documentId, edmDocumentId: deleteIds.toString(), requestType: requestType
      }
    };
    return this.http.delete<DocumentResponse>(environment.apiDocumentsURL, httpOptions);
  }


  retrieveDocuments(downloadIds,requestType): Observable<DocumentResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        edmDocumentId: downloadIds.toString(), requestType: requestType
      }
    };

    return this.http.get<DocumentResponse>(environment.apiDocumentsURL+'/retrieveDocumentByDocId', httpOptions);
  }


  uploadNewOrAddadditionalDocuments(documentRequest: DocumentRequest): Observable<DocumentResponse> {

    //upload additional documents
    if(documentRequest.documentExists === true){
      return this.addAdditionalDocuments(documentRequest);
    }else{
      return this.saveDocumentUpload(documentRequest);
    }
  }

  saveDocumentUpload(documentRequest: DocumentRequest): Observable<DocumentResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    });
    const options = { headers };
    console.log('Inside saveDocumentUpload services => ' + JSON.stringify(documentRequest));
    return this.http.post<DocumentResponse>(environment.apiDocumentsURL, documentRequest, options);
    
  }


  addAdditionalDocuments(documentRequest: DocumentRequest): Observable<DocumentResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    });
    const options = { headers };
    console.log('Inside addAdditionalDocuments services => ' + JSON.stringify(documentRequest));
    return this.http.patch<DocumentResponse>(environment.apiDocumentsURL, documentRequest, options);
    
  }

}

